import request from "@/request";

const eventUtil = {};

eventUtil.collect = async function collect(event) {
    try {
        await request.post(`/page/v5/pay/event-collect`, event);
    } catch (error) {
        console.warn("collect error", error);
    }
};

eventUtil.deviceCollect = async function deviceCollect(context) {
    try {
        const data = await getDeviceDataWithTimeout(context);
        await request.post(`/page/v5/pay/device-collect`, data);
    } catch (error) {
        console.warn("collect error", error);
    }
};

async function collectDeviceInfo(context) {
    try {
        var deviceInfo = {};
        var ipAddress = "";
        var userAgentBrowserValue = getBrowserName(navigator.userAgent);

        // Get the IP address
        const ipPromise = getIpAddress().then(ip => ipAddress = ip);

        // Initialize the FingerprintJS library
        const fpPromise = new Promise((resolve, reject) => {
            if (window.FingerprintJS) {
                resolve(window.FingerprintJS.load());
            } else {
                reject(new Error('FingerprintJS not loaded'));
            }
        });

        // Create a timeout promise that resolves after 5 seconds
        const timeoutPromise = new Promise((_, reject) => {
            setTimeout(() => reject(new Error('Timeout for fingerprint...')), 5000);
        });

        // Wait for either the fingerprint promise or the timeout
        const result = await Promise.race([fpPromise.then(fp => fp.get()), timeoutPromise]);

        await ipPromise;  // Ensure IP address is fetched before proceeding
        deviceInfo = result.components;
        console.log("deviceInfo:", deviceInfo)
        const deviceData = {
            visitorId: result.visitorId,
            tradeId: context.tradeId,
            javaEnabled: navigator.javaEnabled() ? navigator.javaEnabled() : false,
            colorDepth: screen.colorDepth ? screen.colorDepth : 24,
            javaScriptEnabled: true,
            languages: navigator.language,
            acceptLanguages: navigator.language,
            browserAcceptHeader: '',
            screenResolutionWidth: screen.width,
            screenResolutionHeight: screen.height,
            userAgent: navigator.userAgent,
            userAgentBrowserValue: userAgentBrowserValue,
            ipAddress: ipAddress,
            timezoneDuration: deviceInfo['timezone']['duration'],
            timezone: deviceInfo['timezone']['value'],
            deviceMemory: deviceInfo['deviceMemory']['value'],
            screenResolution: deviceInfo['screenResolution']['value'][0] + "," + deviceInfo['screenResolution']['value'][1],
            platform: deviceInfo['platform']['value'],
            vendor: deviceInfo['vendor']['value'],
            pdfViewerEnabled: deviceInfo['pdfViewerEnabled']['value'],
            timezoneOffset: new Date().getTimezoneOffset(),
        };
        // console.log("deviceInfo.tradeId: ", deviceData);
        // console.log(" timezoneOffset", new Date().getTimezoneOffset())
        return deviceData;

    } catch (error) {
        console.warn('Failed to collect device info:', error);
    }
}

// Using the modified collectDeviceInfo with a timeout
async function getDeviceDataWithTimeout(context, timeout = 5000) {
    const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => reject(new Error('collectDeviceInfo timed out')), timeout);
    });

    return Promise.race([collectDeviceInfo(context), timeoutPromise]);
}


// Function to get the IP address using ipify with a fallback timeout
async function getIpAddress() {
    try {
        const fetchWithTimeout = (url, options, timeout = 2000) => {
            return Promise.race([
                fetch(url, options),
                new Promise((_, reject) =>
                    setTimeout(() => reject(new Error('Request timed out')), timeout)
                )
            ]);
        };
        const response = await fetchWithTimeout('https://api.ipify.org?format=json');
        const data = await response.json();
        return data.ip;
    } catch (error) {
        console.warn('Error fetching IP address:', error);
        return 'Unknown';
    }
}

// Function to parse the browser name from the user agent string
function getBrowserName(userAgent) {
    if (userAgent.indexOf("Firefox") > -1) {
        return "Firefox";
    } else if (userAgent.indexOf("Chrome") > -1) {
        return "Chrome";
    } else if (userAgent.indexOf("Safari") > -1) {
        return "Safari";
    } else if (userAgent.indexOf("MSIE") > -1 || !!document.documentMode === true) {
        return "IE"; // MSIE 10 or older or IE 11
    } else if (userAgent.indexOf("Edge") > -1) {
        return "Edge";
    }
    return "Unknown";
}

export default eventUtil;
